import script from "./AdminCustomPages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCustomPages.vue?vue&type=script&setup=true&lang=js"

import "./AdminCustomPages.vue?vue&type=style&index=0&id=c7dacd0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7dacd0a"]])

export default __exports__